import { create } from 'zustand';

import {
  BlockRuleTypeOptions,
  TBlockRuleTypeOptions,
} from '@components/block-event-single/constant/constant';
import { getDefaultBlockEventData } from '@components/block-event-single/utils/initializeUtils';
import { IBlockEventData } from '@src/common/types/empTypes';

export enum EPanelOpenMethod {
  VIEW = 'view',
  CREATE = 'create',
  EDIT = 'edit',
  CLONE = 'clone',
}

interface IBlockEventSinglePanelStore {
  blockEventSingleOpen: boolean;
  panelOpenMethod: EPanelOpenMethod;
  blockType: TBlockRuleTypeOptions;
  blockEventsSingleDataGroup: IBlockEventData[];
  setPanelOpenMethod: (panelOpenMethod: EPanelOpenMethod) => void;
  setBlockType: (blockType: TBlockRuleTypeOptions) => void;
  setBlockEventSingleOpen: (blockEventSingleOpen: boolean) => void;
  setBlockEventsSingleDataGroup: (blockEventsSingleDataGroup: IBlockEventData[]) => void;
  resetBlockEventSingleStore: () => void;
}

export const useBlockEventSinglePanelStore = create<IBlockEventSinglePanelStore>((set) => ({
  blockEventSingleOpen: false,
  panelOpenMethod: EPanelOpenMethod.CREATE,
  blockType: BlockRuleTypeOptions[0].value,
  blockEventsSingleDataGroup: [getDefaultBlockEventData()],
  setPanelOpenMethod: (panelOpenMethod: EPanelOpenMethod) => set(() => ({ panelOpenMethod })),
  setBlockType: (blockType) => set(() => ({ blockType })),
  setBlockEventSingleOpen: (blockEventSingleOpen) => set(() => ({ blockEventSingleOpen })),
  setBlockEventsSingleDataGroup: (blockEventsSingleDataGroup) =>
    set(() => ({ blockEventsSingleDataGroup })),
  resetBlockEventSingleStore: () =>
    set(() => ({
      blockEventSingleOpen: false,
      panelOpenMethod: EPanelOpenMethod.CREATE,
      blockType: BlockRuleTypeOptions[0].value,
      blockEventsSingleDataGroup: [getDefaultBlockEventData()],
    })),
}));
